import { render, staticRenderFns } from "./createDefault.vue?vue&type=template&id=88a39072&scoped=true"
import script from "./createDefault.vue?vue&type=script&lang=js"
export * from "./createDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a39072",
  null
  
)

export default component.exports